import { render, staticRenderFns } from "./PositionNew.vue?vue&type=template&id=2643f336"
import script from "./PositionNew.vue?vue&type=script&lang=js"
export * from "./PositionNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports